import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PanelExpandableComponent } from '@app/shared/ux/panel-expandable/panel-expandable.component';
import { DateService, PolicyValidityStatusCodeEnum, PurchasedProductInterface } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-regular-driver-data',
    templateUrl: './insurance-regular-driver-data.component.html',
})
export class InsuranceRegularDriverDataComponent implements OnInit {

    @Input() public purchasedProduct!: PurchasedProductInterface;
    @Input() public regularDriverForm: PanelExpandableComponent;
    @Input() public openedDriverForm: boolean = false;
    @Output() public openedDriverFormChange: EventEmitter<boolean> = new EventEmitter<boolean>();


    public validityStatusCodeEnum = PolicyValidityStatusCodeEnum;
    public productStartDate: string;
    public currentDate: string;

    constructor(
        private readonly dateService: DateService,
    ) {
    }

    public get hasRegularDriver(): boolean {
        return Boolean(
            this.purchasedProduct?.productDetails?.regularDriver &&
            this.purchasedProduct?.productDetails?.regularDriver?.startDate);
    }

    /**
     * If the product is in future state and the driver is deviant
     * the regular driver is the future regular driver. If the product
     * is active the future regular driver will become the regular
     * driver. In this case we show the future regular driver as
     * regular driver.
     */
    public get hasRegularDriverFuture(): boolean {
        return Boolean(
            !this.purchasedProduct?.productDetails?.regularDriver &&
            this.purchasedProduct?.productDetails?.regularDriverFuture);
    }

    public get isPolicyHolder(): boolean {
        return Boolean(!this.purchasedProduct?.productDetails?.regularDriver);
    }

    public get canAddRegularDriver(): boolean {
        return Boolean(
            !this.purchasedProduct?.productDetails?.regularDriver?.endDate &&
            !this.purchasedProduct?.productDetails?.regularDriverFuture);
    }

    public get regularDriverName(): string {
        return `
            ${this.purchasedProduct?.productDetails?.regularDriver?.genderDescription}
            ${this.purchasedProduct?.productDetails?.regularDriver?.initials}
            ${this.purchasedProduct?.productDetails?.regularDriver?.middleNameInitials}
            ${this.purchasedProduct?.productDetails?.regularDriver?.surname}
        `;
    }

    public get regularDriverFutureName(): string {
        return `
            ${this.purchasedProduct?.productDetails?.regularDriverFuture?.genderDescription}
            ${this.purchasedProduct?.productDetails?.regularDriverFuture?.initials}
            ${this.purchasedProduct?.productDetails?.regularDriverFuture?.middleNameInitials}
            ${this.purchasedProduct?.productDetails?.regularDriverFuture?.surname}
        `;
    }

    public get isActiveProduct(): boolean {
        return [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
        ].includes(this.purchasedProduct?.product?.validityStatusCode);
    }

    public get isFutureProduct(): boolean {
        return Boolean(this.purchasedProduct?.product?.validityStatusCode === PolicyValidityStatusCodeEnum.Future);
    }

    public ngOnInit(): void {
        this.setProductStartDate();
        this.setCurrentDate();
    }

    private setProductStartDate(): void {
        if (this.purchasedProduct?.productDetails?.regularDriver) {
            this.productStartDate = this.dateService
                .format(this.purchasedProduct?.productDetails?.regularDriver?.startDate, '');
        }
    }

    private setCurrentDate(): void {
        this.currentDate = this.dateService.format('', '');
    }
}
